import { render, staticRenderFns } from "./DPHZ.vue?vue&type=template&id=5eff48e2"
import script from "./DPHZ.vue?vue&type=script&lang=js"
export * from "./DPHZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports